import * as React from "react"
import { Link } from "react-router-dom"
import { Action, IOWidget, mk_widget, async, unloadedAsyncState, onlyIf, mkWidget, any, nothing, AsyncState } from "widgets-for-react"
import { AppState, isLoggedInState, LoginState } from '../state';
import { LoginFlowStyle } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";
import { QuotationRequestElement } from '../../quotation_request';
import { CustomRouteParams } from '../router_state';
import { State, PortalRouteParams, ExtraUserInfo } from '../../portal_client';
import { Product, Characteristic, RequestToRetry } from '../types';
import { ProductConfigurationElement } from '../../product_configuration';
import { Header } from "../../header";
import { Overlay } from '../../overlay';
import { asyncWithConnectionError } from '../../../utils/widgets';
import { isConnectionErrorServer, isConnectionErrorUser } from '../../../utils/functions';

export function home(
  rootpath: string,
  options?: { style?: LoginFlowStyle; key?: string }
): IOWidget<AppState<State, PortalRouteParams, ExtraUserInfo>, Action<AppState<State, PortalRouteParams, ExtraUserInfo>>> {
  return (s0: AppState<State, PortalRouteParams, ExtraUserInfo>) => {
    return mk_widget({
      run: (setState: (_: Action<AppState<State, PortalRouteParams, ExtraUserInfo>>) => void) => {
        return (
          isLoggedInState(s0.login)
            ?
            <div className="wrap">
              <Header
                name={s0.login.user.firstname + " " + s0.login.user.lastname}
                company={s0.login.user.company}
                rootpath={rootpath}
                handleLogOut={
                  () => setState(s => {
                    if (isLoggedInState(s.login)) {
                      let appState = s.login.appState
                      appState.isAlertTypeOpen = {
                        ...appState.isAlertTypeOpen,
                        logout: true
                      }
                      return {
                        ...s,
                        login: {
                          ...s.login,
                          appState
                        }
                      }
                    }
                  })
                }
              />

              <main
                className={`main ${s0.login.appState.inDarkMode ? 'main--dark' : ''}`}
                onClick={e =>
                  document.documentElement.classList.contains('menu--toggled')
                    ? document.documentElement.classList.remove('menu--toggled')
                    : null
                }
              >
                <article className="page">
                  {any<Action<LoginState<State, ExtraUserInfo>>>()([
                    asyncWithConnectionError<Product[]>()(isLoggedInState(s0.login) ? s0.login.appState.products : unloadedAsyncState()).map<Action<LoginState<State, ExtraUserInfo>>>(products_updator => s => {
                      if (isLoggedInState(s)) {
                        let { newResult, connectionErrorServer, connectionErrorUser } = products_updator(s.appState.products)
                        let toRetry: RequestToRetry = connectionErrorServer || connectionErrorUser ? { kind: "products", loading: {...s.appState.products, retryCount: 0} } : s.appState.toRetry
                        return ({ ...s, appState: { ...s.appState, toRetry, products: newResult, isAlertTypeOpen: { ...s.appState.isAlertTypeOpen, connectionErrorUser, connectionErrorServer } } })
                      }
                    }),
                    asyncWithConnectionError<Characteristic[]>()(isLoggedInState(s0.login) && s0.login.appState.productConfigurations.get(s0.login.appState.selectedProductConfiguration) ?
                      s0.login.appState.productConfigurations.get(s0.login.appState.selectedProductConfiguration).CharacteristicArray :
                      unloadedAsyncState()).map<Action<LoginState<State, ExtraUserInfo>>>
                      (characteristics_updator => s => {
                        if (isLoggedInState(s)) {
                          let prodconfigs = s.appState.productConfigurations
                          let loadingprodconfigs = s.appState.productConfigurations
                          let toRetry: RequestToRetry = s.appState.toRetry
                          let { newResult, connectionErrorServer, connectionErrorUser } = characteristics_updator(s.appState.productConfigurations.get(s.appState.selectedProductConfiguration).CharacteristicArray)
                          if (loadingprodconfigs.get(s.appState.selectedProductConfiguration).CharacteristicArray.kind == "loading" && newResult.kind == "failed") {
                            let CharacteristicArray = { ...s.appState.productConfigurations.get(s.appState.selectedProductConfiguration).CharacteristicArray, retryCount: 0 }
                            loadingprodconfigs = loadingprodconfigs.set(s.appState.selectedProductConfiguration, { ...loadingprodconfigs.get(s.appState.selectedProductConfiguration), CharacteristicArray })
                            toRetry = { kind: "productConfigurations", loading: loadingprodconfigs }
                          }
                          prodconfigs.get(s.appState.selectedProductConfiguration).CharacteristicArray = newResult
                          if (newResult.kind == "loaded") {
                            if (prodconfigs.get(s.appState.selectedProductConfiguration).SelectedCharacteristic == "ProductId") {
                              prodconfigs.get(s.appState.selectedProductConfiguration).SelectedCharacteristic = "Count"
                            } else {
                              let index = newResult.value.indexOf(newResult.value.find(c => c.Id == prodconfigs.get(s.appState.selectedProductConfiguration).SelectedCharacteristic))
                              let nextCharacteristicId = newResult.value.slice(index + 1).find(c => c.ValueOptions.length != 1) ? newResult.value.slice(index + 1).find(c => c.ValueOptions.length != 1).Id : "0"
                              prodconfigs.get(s.appState.selectedProductConfiguration).SelectedCharacteristic = nextCharacteristicId
                            }
                          }
                          return ({ ...s, appState: { ...s.appState, toRetry, isAlertTypeOpen: { ...s.appState.isAlertTypeOpen, connectionErrorUser, connectionErrorServer }, productConfigurations: prodconfigs, cachedCharacteristics: newResult.kind == "loaded" ? newResult.value : s.appState.cachedCharacteristics } })
                        }
                      }),
                    mkWidget({ run: setState => QuotationRequestElement(() => isLoggedInState(s0.login) ? s0.login.user : null, setState, s0.login) }),
                  ])
                  .run(a => setState(s => {
                    let newLogin = a(s.login)
                    return { ...s, login: newLogin }
                  }))}
                </article>
                <Overlay type="alert" alertType="editCharacteristic" user={() => isLoggedInState(s0.login) ? s0.login.user : null} setState={updateLoginState => setState(s => ({ ...s, login: updateLoginState(s.login) }))} state={s0.login} />
                <Overlay type="alert" alertType="logout" user={() => isLoggedInState(s0.login) ? s0.login.user : null} setState={updateLoginState => setState(s => ({ ...s, login: updateLoginState(s.login) }))} state={s0.login} />
                <Overlay type="alert" alertType="connectionErrorUser" user={() => isLoggedInState(s0.login) ? s0.login.user : null} setState={updateLoginState => setState(s => ({ ...s, login: updateLoginState(s.login) }))} state={s0.login} />
                <Overlay type="alert" alertType="connectionErrorServer" user={() => isLoggedInState(s0.login) ? s0.login.user : null} setState={updateLoginState => setState(s => ({ ...s, login: updateLoginState(s.login) }))} state={s0.login} />
                <Overlay type="alert" alertType="cancelConfiguration" user={() => isLoggedInState(s0.login) ? s0.login.user : null} setState={updateLoginState => setState(s => ({ ...s, login: updateLoginState(s.login) }))} state={s0.login} />
              </main>
            </div>
            : <></>
        )
      }
    })
  }
}
